import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { floorClickableRegions } from "./floorData";
import { freeParking, freeApartments } from "../floor/apartmentsData";
import "./Overview.css";

function Overview({ available = {} }) {
  const { t } = useTranslation("portfolio");

  const { apartments = freeApartments, parking = freeParking } = available;
  const floors = [-2, -1, ...Array.from({ length: 6 }, (_, i) => i + 1)];
  const [selectedFloor, setSelectedFloor] = useState("");

  const handleSubmit = () => {
    if (selectedFloor) {
      sessionStorage.setItem("selectedFloor", selectedFloor);
      const url = `/innerpages/floor?floor=${selectedFloor}`;
      window.location.href = url;
    } else {
      alert(t("overview.form.validationMessage"));
    }
  };

  const handleFloorImageClick = (floor) => {
    sessionStorage.setItem("selectedFloor", floor);
    const url = `/innerpages/floor?floor=${floor}`;
    window.location.href = url;
  };

  return (
    <div className="overview-container">
      <div className="overview-image">
        <img
          src="/home1/assets/img/slider/head_slide9.jpg"
          alt="Botanicheska 302"
          useMap="#building-map"
        />
        <map name="building-map">
          {floorClickableRegions.map(({ floor, coords }) => (
            <area
              key={floor}
              shape="poly"
              coords={coords}
              alt={`Floor ${floor}`}
              onClick={() => handleFloorImageClick(floor)}
              style={{ cursor: "pointer" }}
            />
          ))}
        </map>
      </div>

      <div className="overview-info">
        <h4 className="overview-subtitle">{t("overview.available")}</h4>

        <div className="stats-wrapper">
          {[
            {
              label: t("overview.stats.apartments"),
              value: apartments,
              url: "/innerpages/floor?entrance=А&floor=2",
            },
            {
              label: t("overview.stats.parking"),
              value: parking,
              url: "/innerpages/floor?entrance=А&floor=-1",
            },
          ].map(({ label, value, url }) => (
            <a key={label} href={url} className="stat-item">
              <div className="stat-circle">{value}</div>
              <div className="stat-label">{label}</div>
            </a>
          ))}
        </div>

        <div className="blue-form">
          <div className="form-group">
            <label htmlFor="floor">{t("overview.form.floor")}</label>
            <select
              id="floor"
              value={selectedFloor}
              onChange={(e) => setSelectedFloor(e.target.value)}
            >
              <option value="">-</option>
              {floors.map((f) => (
                <option key={f} value={f}>
                  {f}
                </option>
              ))}
            </select>
          </div>

          <button className="search-button" onClick={handleSubmit}>
            {t("overview.form.searchButton")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Overview;
